import { pickGenericEnemyCard } from './generic';
import type { EnemyAiDecision, EnemyAiDecisionContext } from './types';

export function pickChymistCard(context: EnemyAiDecisionContext): EnemyAiDecision {
  return pickGenericEnemyCard(context);
}
